enum EstadosReservasEnum {
  Pendiente = 1,
  Aprobado = 2,
  Rechazado = 3,
}



export default EstadosReservasEnum;